import { z } from 'zod';

import { BaseReferenceDto } from '@cfa/pathway-fe-shared/xp';

import { itemByLanguage } from './language';

const localizedReferenceSchema = z.object({
  icon: z.string(),
});

export const getIconFromReference = (
  reference: Record<string, BaseReferenceDto>,
) => {
  const localizedReference = itemByLanguage(reference);

  const parsedLocalizedReference =
    localizedReferenceSchema.safeParse(localizedReference);

  if (parsedLocalizedReference.success) {
    return parsedLocalizedReference.data.icon;
  }

  return 'Chickfila';
};
